import { Anchor, Text } from "@mantine/core"
import { IconExternalLink } from "@tabler/icons-react"

export const COST_METRIC_DESCRIPTIONS: Record<string, React.ReactNode> = {
  cost: (
    <>
      <Text size="xs" c="dimmed" mt="xs">
        The cost you see in your GCP / AWS / Azure invoices It includes all
        credits / commitment effects.
        <br />
        <br />
        Equivalent to:
        <br />• AWS: <i>Net unblended cost</i>
        <br />• GCP: <i>Cost - Credits</i>
        <br />• Azure: <i>Actual Cost</i>
      </Text>
    </>
  ),
  contracted_cost: (
    <Text size="xs" c="dimmed" mt="xs">
      Your costs if you did have any savings plans or commitments except your
      EDP.
      <br />
      <br />
      Compare to billed cost to see the impact of savings plans and usage
      discounts.
      <br />
      <br />
      See more:
      <br />• AWS:{" "}
      <Anchor
        href="https://help.costory.io/en/articles/11994212-understanding-contracted-cost-vs-list-cost-vs-billed-cost-in-aws"
        target="_blank"
      >
        <IconExternalLink size={16} />
      </Anchor>
      <br />• GCP:{" "}
      <Anchor
        href="https://help.costory.io/en/articles/11010058-understanding-contracted-cost-vs-list-cost-vs-billed-cost-in-google-cloud"
        target="_blank"
      >
        <IconExternalLink size={16} />
      </Anchor>
    </Text>
  ),
  list_cost: (
    <Text size="xs" c="dimmed" mt="xs">
      Your costs at full retail prices - without any EDP, commitments, or
      credits.
      <br />
      <br /> For customers with EDP the cost values can be very high and should
      be ignored.
    </Text>
  ),
  effective_cost: (
    <Text size="xs" c="dimmed" mt="xs">
      Your costs with amortization of upfront savings plans & reservations fees.
      <br />
      <br />
      If you rely on Savings Plans and Reservations to get discounts, this is
      the cost you should use.
      <br />
      <br />
      Equivalent to:
      <br />• AWS: <i>Net amortized cost</i>{" "}
      <Anchor
        href="https://help.costory.io/en/articles/11994212-understanding-contracted-cost-vs-list-cost-vs-billed-cost-in-aws?q=gcp+amortized"
        target="_blank"
      >
        <IconExternalLink size={16} />
      </Anchor>
      <br />• GCP: <i>Cost</i>
      <br />• Azure: <i>Amortized cost</i>
    </Text>
  ),
  unblended_cost: (
    <>
      <Text size="xs" c="dimmed" mt="xs">
        Unblended Cost is the cost before any credits or discounts are applied.
        <br />
        <br />
        Equivalent to:
        <br />• AWS: <i>Unblended Cost (excluding Taxes)</i>
        <br />• GCP: <i>Cost (excluding Promotional credits & Taxes)</i>
        <br />• Azure: <i>Actual Cost</i>
      </Text>
    </>
  ),
  net_unblended_cost: (
    <>
      <Text size="xs" c="dimmed" mt="xs">
        Net Unblended Cost is the cost after any credits or discounts are
        applied. It is the same as cost in Costory cost.
        <br />
        <br />
        Equivalent to:
        <br />• AWS: <i>Net unblended cost (excluding Taxes)</i>
        <br />• GCP: <i>Cost with credits applied</i>
        <br />• Azure: <i>Actual Cost</i>
      </Text>
    </>
  ),
  amortized_cost: (
    <>
      <Text size="xs" c="dimmed" mt="xs">
        Amortized Cost is the amortized cost before any credits or discounts are
        applied.
        <br />
        <br />
        If you rely on Savings Plans and Reservations to get discounts, this is
        the cost you should use.
        <br />
        <br />
        Equivalent to:
        <br />• AWS: <i> Amortized cost</i>
        <br />• GCP: <i>Cost with credits applied (same as Unblended Cost)</i>
        <br />• Azure: <i>Amortized Cost</i>
      </Text>
    </>
  ),
  net_amortized_cost: (
    <>
      <Text size="xs" c="dimmed" mt="xs">
        Net Amortized Cost is the amortized cost after any credits or discounts
        are applied. It is the same as effective cost in Costory cost. If you
        rely on Savings Plans and Reservations to get discounts, this is the
        cost you should use.
        <br />
        <br />
        Equivalent to:
        <br />• AWS: <i>Net amortized cost</i>
        <br />• GCP:{" "}
        <i>Cost with credits applied (same as net Unblended Cost)</i>
        <br />• Azure: <i>Amortized Cost</i>
      </Text>
    </>
  ),
}

export const ICON_SIZE = 14
